module.exports = __webpack_public_path__ + "img/readingtask4passage.a6d415d7.png";